import { render, staticRenderFns } from "./Passages.vue?vue&type=template&id=54572bdc&scoped=true&"
import script from "./Passages.vue?vue&type=script&lang=js&"
export * from "./Passages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54572bdc",
  null
  
)

export default component.exports